<template>
  <v-list-item
    :key="sensor.uuid"
    :class="['sensor-pill', { 'sensor-pill--selected': selected }]"
    :style="sensorColorStyle"
  >
    <v-list-item-content>
      <v-list-item-title
        >{{ sensor.name }}
        <v-progress-circular
          v-if="loading"
          :size="16"
          :width="1"
          indeterminate
        ></v-progress-circular>
      </v-list-item-title>

      <v-list-item-subtitle>
        <span v-if="sensor.name != sensor.sensor.name">{{
          sensor.sensor.name
        }}</span>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-list-item-action-text
            v-bind="attrs"
            v-on="on"
            v-text="sensor.last_record_value"
          ></v-list-item-action-text>
        </template>
        <span>
          {{
            sensor.last_record_at
              ? $moment(sensor.last_record_at).format("YYYY-MM-DD H:mm:ss a")
              : $t("components.miscellaneous.sensorPill.noData")
          }}</span
        >
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: "SensorPill",
  props: {
    sensor: Object,
    selected: Boolean,
    loading: Boolean,
    noData: Boolean,
  },
  computed: {
    sensorColorStyle() {
      return this.selected ? { "--sensor-color": this.sensor.color } : {};
    },
  },
};
</script>

<style scoped>
.sensor-pill {
  border-right: 6px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s ease;
}

.sensor-pill--selected {
  border-right-color: var(--sensor-color);
}
</style>
